import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { PageLoader } from './ui/PageLoader';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const { user, session, initialized } = useAuthStore();

  if (!initialized) {
    return (
      <PageLoader
        title="Cargando sesion"
        description="Estamos validando tu acceso antes de mostrarte el panel."
      />
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return (
      <PageLoader
        title="Cargando perfil"
        description="Preparamos tu configuracion y permisos para entrar al modulo correcto."
      />
    );
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === 'superadmin') return <Navigate to="/superadmin" replace />;
    if (user.role === 'admin_taller' || user.role === 'tecnico') return <Navigate to="/admin" replace />;
    if (user.role === 'cliente') return <Navigate to="/client" replace />;
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
